import React, { useState, useEffect } from "react";
import axios from "axios";
import "../CheckAvailability/UserAvailability.css";
import MiniDrawer from "../../../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ContentPasteSearchTwoToneIcon from "@mui/icons-material/ContentPasteSearchTwoTone";
import { useNavigate } from "react-router-dom";

const UserAvailability = () => {
  const [userAvailability, setUserAvailability] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseAPI = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [filterdata, setFilterdata] = useState("True");



  useEffect(() => {
    checkAvailabilty('True');
  }, [baseAPI]);


  const handleChange = (e) => {
    setFilterdata(e.target.value);
    checkAvailabilty(e.target.value);
  };





  function checkAvailabilty(availability)
  {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}/Userget/GetAllAvailabileUser?department_id=3&filterdata=${availability}`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setUserAvailability(response.data.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching user availability:", error);
          setError("Failed to fetch user availability");
          setLoading(false);
        });
    }
  }


  const toggleAvailability = (userId, currentAvailability) => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      const newAvailability = currentAvailability === 1 ? 0 : 1;

      axios
        .post(
          `${baseAPI}/UserPost/SetUserAvailability1`,
          {
            UserId: userId,
            isAvailable: newAvailability,
          },
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
         
          setUserAvailability((prevUsers) =>
            prevUsers.map((user) =>
              user.Customer_Id === userId ? { ...user, is_available: newAvailability } : user
            )
          );
        })
        .catch((error) => {
          console.error("Error updating user availability:", error);
        });
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  function DetailIconClick(Customer_Id) {

    navigate("/AvailabilityView", { state: { userid: Customer_Id } });
  }

  return (
    <div className="d-flex flex-row app">
      <MiniDrawer />
      <div className="container-fluid" style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}>
        <div className="d-flex flex-column w-100" style={{ backgroundColor: "#F4F4F4" }}>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                User Availability | <HomeOutlinedIcon /> <span style={{ fontSize: "20px" }}>&gt; User</span>
              </h1>
            </div>
          </div>

          <div className="container-fluid User-availability" style={{ margin: "2rem 0" }}>
            <div style={{ display: "flex", overflowX: "auto" }}>
              <div className=" headerButton" style={{ display: "flex", gap: "10px", justifyContent: "left" }}>
                <div>
                  <select
                    style={{
                      marginBottom: "1rem",
                      width: "11rem",
                      height: "2.5rem",
                      borderRadius: "0.5rem",
                      fontSize: "13px",
                      fontWeight: "bold"
                    }}
                    name="filterdata"
                    value={filterdata}
                    onChange={handleChange}
                  >
                    <option value="All">All</option>
                    <option value="False">Unavailable</option>
                    <option value="True">Available</option>

                  </select>
                </div>
              </div>
            </div>
            <div className="UserAvailabl">
              <form className="UserAvailability-form">
                <table style={{ width: "100%" }}>
                  <thead style={{backgroundColor:"#F8F9FA"}}>
                    <tr className="tableHeading">
                      <th>User Name</th>
                      <th>Email</th>
                      <th>Current Status</th>
                      <th style={{ textAlign: "right" }}>Change Availability</th>
                      <th style={{ textAlign: "right" }}>Detail</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userAvailability.map((user) => (
                      <tr key={user.Customer_Id}>
                        <td>{user.Name}</td>
                        <td>{user.Email}</td>
                        <td style={{ color: user.is_available ? "green" : "red", fontWeight: "bold" }}>
                          {user.is_available ? "Available" : "Unavailable"}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          <button
                            style={{
                              backgroundColor: "white",
                              color: user.is_available ? "red" : "green",
                              fontWeight: "600",
                              border: user.is_available ? "1px solid red" : "1px solid green",
                              padding: "5px 10px",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              toggleAvailability(user.Customer_Id, user.is_available);
                            }}
                          >
                            {user.is_available ? "Set Unavailable" : "Set Available"}
                          </button>
                        </td>
                        <td>
                          <button
                            style={{ height: "30px", width: "38px" }}
                            onClick={() => DetailIconClick(user.Customer_Id)}
                          >
                            <ContentPasteSearchTwoToneIcon />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserAvailability;
